import { loyaltyTeamSettingsSchema } from "@redotech/redo-loyalty-common/loyalty-definition";

export const updateLoyaltyPopupSettings = {
  name: "updateLoyaltyPopupSettings" as const,
  input: loyaltyTeamSettingsSchema.omit({ enabled: true }),
  output: loyaltyTeamSettingsSchema.omit({ enabled: true }),
};
